export * from './OfferLogo'
